export const primaryColor = "#f33141"
export const whiteColor = "#ffffff"
export const blackColor = "#000000"
export const dashboardColor = "#23282D"